/**
 * Rental agreement status values
 */
export enum RentalAgreementStatusEnum {
	/**
	 * Rental agreement is pending
	 */
	PENDING = 'pending',
	/**
	 * Rental agreement is in progress
	 */
	IN_PROGRESS = 'in_progress',
	/**
	 * Rental agreement is completed
	 */
	COMPLETED = 'completed',
	/**
	 * Rental agreement is cancelled
	 */
	CANCELLED = 'cancelled',
}
